import { BOARD_SIZE } from '../../config/board.ts'
import { evalPosition } from '../eval.ts'
import type { Board, Color, Move, Player } from './types.ts'
import { pickBest } from './types.ts'

function opponent(c: Color): Color {
  return c === 'black' ? 'white' : 'black'
}

function hasAnyStone(board: Board): boolean {
  for (const row of board) for (const cell of row) if (cell !== 'empty') return true
  return false
}

export const greedyPlayer: Player = {
  id: 'greedy',
  name: 'Greedy 1-ply',
  decide(board, color, { rng, forbidden, allowedMoves }) {
    const opp = opponent(color)

    if (allowedMoves && allowedMoves.length > 0) {
      const cs = allowedMoves.map(m => ({
        score: evalPosition(board, m.row, m.col, color, opp),
        item: m,
      }))
      return pickBest(cs, rng)
    }

    if (!hasAnyStone(board)) {
      const center = Math.floor(BOARD_SIZE / 2)
      const centerKey = center * BOARD_SIZE + center
      if (!forbidden?.has(centerKey)) {
        return { row: center, col: center }
      }
      // 中央が禁止 → 一般評価に委ねる
    }

    const candidates: { score: number; item: Move }[] = []
    for (let r = 0; r < BOARD_SIZE; r++) {
      for (let c = 0; c < BOARD_SIZE; c++) {
        if (board[r][c] !== 'empty') continue
        if (forbidden?.has(r * BOARD_SIZE + c)) continue
        const score = evalPosition(board, r, c, color, opp)
        candidates.push({ score, item: { row: r, col: c } })
      }
    }
    return pickBest(candidates, rng)
  },
}
